import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams, useHistory } from "react-router-dom";
import { getClient } from "@State/index";
import ClientFullTable from "./ClientFullTable";
import ButtonBB from "@View/components/buttons/ButtonBB";
import Scoring from "@View/components/Scoring";
import ClientScoring from "./ClientScoring";
import { downloadFileWithNotification } from "@State/effects";
import { getHeaderLeftComponent } from "@View/components/headers/HeaderMain";
import UploadFileModal from "../../customer/customerDetails/UploadFileModal";
import ClientsDetails from "./ClientsDeatils";
import { changeAppLanguage } from "@Localization/utils";
import { canAddAbility, getRole } from "@Security/stateHelpers";
import BankStatementsModal from "@View/pages/AdminPO/customer/customerDetails/BankStatementsModal";
import BankStatements1CModal from "@View/pages/AdminPO/customer/customerDetails/BankStatements1CModal";
import { downloadFile } from "@Dao/api";
import getAPI from "@API/index";
import CreditReportAversModal from "@View/pages/AdminPO/customer/customerDetails/CreditReportModal";
import { format } from "date-fns";
import { IsCreditRatingSDM, IsCreditOpinionAvers, IsCreditOpinionSDM, IsProfJudgmentAvers, IsProfJudgmentDalnevostochniy, IsCreditOpinionCreditAnalysis, IsCreditOpinionNBD, IsProfJudgmentCreditAnalysis } from "@Constants/tokens";
import SDMClientRKK from "./SDMClientRKK";
import SDMClientCreditOpinion from "./SDMClientCreditOpinion";
import CreditAnalysisClientProfJudgment from "./CreditAnalysisClientProfJudgment";
import { useBackButton } from "@View/hooks/useBackButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const ClientDetailsPage = () => {
  const { id: clientId } = useParams();
  const history = useHistory();

  const location = useLocation();

  useEffect(() => {
    if (location.state?.creditScoreOpen) {
      handleOpenScoring();
    }
    if (location.state?.addFinDataOpen) {
      handleOpenUpload();
    }
  }, []);

  const dispatch = useDispatch();
  const client = useSelector((state) => state.client.client);
  const [isMfo, setIsMfo] = useState(false);

  useEffect(() => {
    dispatch(getClient(clientId));
  }, [getClient, clientId]);

  useEffect(() => {
    let isActive = true;

    getAPI()
      .request({
        url: `/api/CreditAnalysis/client/${clientId}/professional-judgment/client-type`,
      })
      .then((response) => {
        if (isActive) {
          setIsMfo(response?.data === "MKK" || response?.data === "MFK");
        }
      })
      .catch(() => {
        if (isActive) {
          setIsMfo(false);
        }
      });

    return () => {
      isActive = false;
    };
  }, [clientId]);

  const { t, i18n } = useTranslation();

  const [openDetails, setOpenDetails] = React.useState(false);

  const handleOpenDetails = () => {
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  const [openScoring, setOpenScoring] = React.useState(false);
  const [openRatingRKK, setOpenRatingRKK] = React.useState(false);
  const [openSDMCreditOpinion, setOpenSDMCreditOpinion] = React.useState(false);

  const handleOpenScoring = () => {
    if (IsCreditRatingSDM()) {
      setOpenRatingRKK(true);
    } else {
      setOpenScoring(true);
    }
  };

  const handleCloseScoring = () => {
    setOpenScoring(false);
  };

  const handleCloseRatingRKK = () => {
    setOpenRatingRKK(false);
  };

  React.useEffect(() => {
    if (client?.defaultLanguage) {
      changeAppLanguage(client.defaultLanguage);
    }
  }, [client]);

  const LeftComponent = () => {
    const backButtonVisible = useBackButton();

    return (
      <div
        onClick={() => handleOpenDetails()}
        style={{
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          marginLeft: backButtonVisible ? "24px" : "",
        }}
      >
        <div
          style={{
            marginRight: "15px",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "19px",
            color: "#1A1E24",
          }}
        >
          {client.name}
        </div>
        <InfoOutlinedIcon
          titleAccess={t("Client Details")}
          sx={{
            fontSize: 18,
            color: "#54606F",
            "&:hover": { color: "#1A1E24" },
          }}
        />
      </div>
    );
  };

  React.useEffect(() => {
    dispatch(getHeaderLeftComponent(LeftComponent));
  }, [client]);

  const handleClick = async (id) => {
    await downloadFileWithNotification(id);
  };

  const [judgmentLoading, setJudgmentLoading] = React.useState(false);
  const downloadJudgmentFile = async (client, { startDate, endDate }) => {
    const params = new URLSearchParams({
      start: format(startDate, "MM.dd.yyyy"),
      end: format(endDate, "MM.dd.yyyy"),
    }).toString();
    setJudgmentLoading(true);
    if (IsProfJudgmentAvers()) {
      await downloadFile(
        `/api/Client/${client.id}/avers-estimate-report?${params}`
      );
    } else if (IsProfJudgmentDalnevostochniy()) {
      await downloadFile(
        `/api/Client/${client.id}/professional-judgment/file?${params}`
      );
    } else if (IsProfJudgmentCreditAnalysis()) {
      setJudgmentLoading(false);
      handleOpenCreditAnalysisClientProfJudgment();
      return;
    } else {
      await downloadFile(
        `/api/Client/${client.id}/professional-judgment/file?${params}`
      );
    };
    setJudgmentLoading(false);
  };

  const [isCreditAnalysisClientProfJudgmentOpen, setIsCreditAnalysisClientProfJudgmentOpen] =
    React.useState(false);

  const handleOpenCreditAnalysisClientProfJudgment = () => {
    setIsCreditAnalysisClientProfJudgmentOpen(true);
  };

  const handleCloseCreditAnalysisClientProfJudgment = () => {
    setIsCreditAnalysisClientProfJudgmentOpen(false);
  };

  const handleSaveCreditAnalysisClientProfJudgment = () => {
    // save is handled inside CreditAnalysisClientProfJudgment
  };

  const [openUpload, setOpenUpload] = React.useState(false);

  const handleOpenUpload = () => {
    openBankStatements();
  };

  const handleCloseUpload = () => {
    setOpenUpload(false);
  };

  const [isBankStatements1COpen, setIsBankStatements1COpen] =
    React.useState(false);

  const openBankStatements1C = () => {
    setIsBankStatements1COpen(true);
  };
  const closeBankStatements1C = () => {
    setIsBankStatements1COpen(false);
  };

  const [isBankStatementsOpen, setIsBankStatementsOpen] = React.useState(false);
  const openBankStatements = () => {
    setIsBankStatementsOpen(true);
  };
  const closeBankStatements = () => {
    setIsBankStatementsOpen(false);
  };

  const [isCreditReportAversModalOpen, setIsCreditReportAversModalOpen] =
    React.useState(false);

  const handleCreditReportButtonClick = () => {
    if (IsCreditOpinionSDM()) {
      setOpenSDMCreditOpinion(true);
    } else if (IsCreditOpinionAvers()) {
      setIsCreditReportAversModalOpen(true);
    } else if (IsCreditOpinionCreditAnalysis()) {
      downloadCreditOpinionFile(`/api/CreditAnalysis/client/${clientId}/credit-opinion/file`, `credit_opinion_finstar_${clientId}.xlsx`);
    } else if (IsCreditOpinionNBD()) {
      downloadCreditOpinionFile(`/api/nbd/client/${clientId}/credit-opinion/file`, `credit_opinion_nbd_${clientId}.xlsm`);
    } else {
      history.push(`/creaditOpinion/${clientId}`);
    }
  };

  const downloadCreditOpinionFile = async (fileUrl, fileName) => {
    try {
      const fileSettings = { name: fileName };
      const blob = await getAPI().request({
        url: fileUrl,
        method: "get",
        responseType: 'blob',
        _fileSettings: fileSettings,
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileSettings.name;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("[downloadCreditOpinionFile]", error);
    }
  };

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    if (client?.finDataRequests && client.finDataRequests.length > 0) {
      const dates = client.finDataRequests
        .flatMap((request) => [
          new Date(request.startDate),
          new Date(request.endDate),
        ])
        .filter((date) => !isNaN(date.getTime()));

      if (dates.length > 0) {
        const minDate = new Date(Math.min(...dates));
        const maxDate = new Date(Math.max(...dates));

        setStartDate(minDate);
        setEndDate(maxDate);
      }
    } else {
      const nowDate = new Date();
      setStartDate(new Date(nowDate.getFullYear() - 1, nowDate.getMonth(), 1));
      setEndDate(new Date(nowDate.getFullYear(), nowDate.getMonth(), 1));
    }
  }, [client?.finDataRequests]);

  if (Object.keys(client).length === 0 || !startDate || !endDate) return null;

  return (
    <div style={{ width: "100%" }} className="clientDetails__page">
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          position: "absolute",
          right: i18n.language === "en" ? "350px" : "380px",
        }}
      ></div>

      <ClientsDetails
        client={client}
        open={openDetails}
        handleOpen={handleOpenDetails}
        handleClose={handleCloseDetails}
      />
      {openScoring ? (
        <ClientScoring handleClose={handleCloseScoring} clientId={clientId} />
      ) : null}
      {openRatingRKK ? (
        <SDMClientRKK handleClose={handleCloseRatingRKK} clientId={clientId} clientName={client?.name} />
      ) : null}
      {openSDMCreditOpinion ? (
        <SDMClientCreditOpinion handleClose={() => setOpenSDMCreditOpinion(false)} clientId={clientId} clientName={client?.name} />
      ) : null}

      <ClientFullTable
        client={client}
        addClientFinData={handleOpenUpload}
        dateFilter={{ startDate, endDate, setStartDate, setEndDate }}
        topButtons={
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Scoring onClick={handleOpenScoring} />
            {getRole() === "Admin" ||
              getRole() === "CustomerUser" ||
              getRole() === "CustomerManager" ? (
              <ButtonBB
                style={{ marginRight: "10px" }}
                onClick={handleCreditReportButtonClick}
              >
                {t(isMfo ? "CreaditOpinion.btnNameMfo" : "CreaditOpinion.btnName")}
              </ButtonBB>
            ) : null}
            {/*<ButtonBB*/}
            {/*  style={{ marginRight: "10px" }}*/}
            {/*  onClick={() => handleClick(client.fileId)}*/}
            {/*>*/}
            {/*  {t("Download integration file")}*/}
            {/*</ButtonBB>*/}
            <ButtonBB
              style={{ marginRight: "10px" }}
              disabled={judgmentLoading}
              onClick={() =>
                downloadJudgmentFile(client, { startDate, endDate })
              }
            >
              {t(isMfo ? "ProfessionalJudgmentMfo" : "ProfessionalJudgment")}
            </ButtonBB>
            {canAddAbility() && (
              <ButtonBB onClick={() => handleOpenUpload()}>
                {t("buttons.Upload Financial Data")}
              </ButtonBB>
            )}
          </div>
        }
      />

      <UploadFileModal
        open={openUpload}
        client={client}
        handleOpen={handleOpenUpload}
        handleClose={handleCloseUpload}
        openBankStatements={openBankStatements}
        openBankStatements1C={openBankStatements1C}
      />
      <CreditReportAversModal
        open={isCreditReportAversModalOpen}
        client={client}
        handleOpen={() => setIsCreditReportAversModalOpen(true)}
        handleClose={() => setIsCreditReportAversModalOpen(false)}
      />
      <BankStatements1CModal
        open={isBankStatements1COpen}
        handleClose={closeBankStatements1C}
        client={client}
      />
      <BankStatementsModal
        open={isBankStatementsOpen}
        handleClose={closeBankStatements}
        client={client}
      />
      <CreditAnalysisClientProfJudgment
        open={isCreditAnalysisClientProfJudgmentOpen}
        onClose={handleCloseCreditAnalysisClientProfJudgment}
        clientId={client?.id}
        clientName={client?.name}
        isMfo={isMfo}
      />
    </div>
  );
};

export default ClientDetailsPage;
